import { useTranslation } from 'next-i18next'
import useConfig from 'modules/config/state/use-config'
import useFlow from 'modules/flow/state/use-flow'
import Column from 'modules/ui/atoms/Layout/Column'
import OrderCommentDrawerOpener from 'modules/order/components/comment/order-comment-drawer-opener'
import OrderDedicationDrawerOpener from 'modules/order/components/dedication/order-dedication-drawer-opener'
import OrderDesignationDrawerOpener from 'modules/order/components/designation/order-designation-drawer-opener'
import OrderDonorCoveredFees from 'modules/order/components/donor-covered-fees/order-donor-covered-fees'
import OrderDoubleTheDonationDrawerOpener from 'modules/order/components/double-the-donation/order-double-the-donation-drawer-opener'
import FlowTwoColumnStepLayout from 'modules/flow/components/two-column-step-layout/two-column-step-layout'
import { trackFormSubmitEvent } from '../../../analytics/helpers/track-form-events'
import useDrawer from '../../../drawer/state/use-drawer'

const OptionsStep = () => {
  const { t } = useTranslation()
  const flow = useFlow()
  const config = useConfig()
  const drawer = useDrawer()

  const onNext = () => {
    trackFormSubmitEvent(flow.currentStep.name)

    flow.nextStep && flow.goToStep(flow.nextStep.name)
    drawer.close()
  }

  return (
    <>
      <FlowTwoColumnStepLayout.Header
        title={flow.currentStep.title}
        backButtonDataId="options-step-back-button"
      />
      <FlowTwoColumnStepLayout.Body>
        <Column style={{ marginBottom: '16px' }}>
          <OrderDonorCoveredFees />
        </Column>
        <Column>
          {!config.designation.isOptional && <OrderDesignationDrawerOpener />}
          {!config.dedication.isOptional && <OrderDedicationDrawerOpener />}
          {!config.comment.isOptional && <OrderCommentDrawerOpener />}
          {!config.doubleTheDonation.isOptional && <OrderDoubleTheDonationDrawerOpener />}
        </Column>
      </FlowTwoColumnStepLayout.Body>
      <FlowTwoColumnStepLayout.Footer>
        <FlowTwoColumnStepLayout.FooterButton
          onClick={onNext}
          dataId="options-step-continue-button"
        >
          {t('OptionsStep.footerButton.continue', 'Continue')}
        </FlowTwoColumnStepLayout.FooterButton>
      </FlowTwoColumnStepLayout.Footer>
    </>
  )
}

export default OptionsStep
